if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // 基本引用，容错处理，避免初始化阶段抛错
        this.form = this.querySelector('form');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('.product-form__submit') || this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        // 柔性处理：有隐藏的 id 输入时才尝试启用
        try {
          if (this.variantIdInput) this.variantIdInput.disabled = false;
        } catch (_) {}

        // 绑定提交事件（表单存在时）
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        // Fallback：按钮点击也强制拦截并跳转，避免未绑定 submit 时走默认加车
        if (this.submitButton) {
          this.submitButton.addEventListener('click', (e) => {
            // 防止原生提交导致进入购物车
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation?.();
            this.redirectToAddress();
          }, { capture: true });
        }

        // 同步拦截动态结账按钮（部分主题可能启用）。即使存在也跳地址页。
        try {
          const interceptDynamicButton = () => {
            const dynContainer = document.querySelector('.shopify-payment-button__button');
            const dynRoleBtn = document.querySelector('.shopify-payment-button__button [role="button"]');
            const bind = (el) => el && el.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation?.();
              this.redirectToAddress();
            }, { capture: true });
            bind(dynContainer);
            bind(dynRoleBtn);
          };
          interceptDynamicButton();
          const mo = new MutationObserver(() => interceptDynamicButton());
          mo.observe(document.body, { childList: true, subtree: true });
        } catch (_) {}

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // 始终跳转到自定义地址表单，不再执行默认加车逻辑
        this.redirectToAddress();
        return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      redirectToAddress() {
        try {
          // 优先使用模板传入的地址页URL，其次回退到默认地址页
          const dsUrl = (this.dataset && this.dataset.addressPageUrl) ? String(this.dataset.addressPageUrl).trim() : '';
          const rawBase = dsUrl || '/pages/address';

          // 采集必要的参数：变体ID、数量、价格文案、币种、语言、标题及图片
          const variantId = (() => {
            try { return this.variantIdInput?.value || ''; } catch (_) { return ''; }
          })();
          const qty = (() => {
            try {
              // 优先读取与该section绑定的数量输入
              const sid = this.dataset && this.dataset.sectionId ? String(this.dataset.sectionId) : '';
              const qEl = sid ? document.querySelector(`#Quantity-${sid}`) : null;
              const val = (qEl?.value || '').trim();
              const n = parseInt(val || '1', 10);
              return isNaN(n) ? 1 : n;
            } catch (_) { return 1; }
          })();

          const priceText = this.getDisplayedPriceText();
          const currency = this.detectActiveCurrency(this.dataset?.currency || '');
          const locale = (this.dataset?.locale || document.documentElement.lang || '').trim();
          const title = (this.dataset?.productTitle || '').trim();
          const variantTitle = (this.dataset?.variantTitle || '').trim();
          const image = (this.dataset?.productImage || '').trim();

          // 构造查询参数
          const params = new URLSearchParams();
          if (variantId) params.set('variant_id', variantId);
          params.set('quantity', String(qty));
          if (priceText) params.set('price_text', priceText);
          if (currency) params.set('currency', currency);
          if (locale) params.set('locale', locale);
          if (title) params.set('title', title);
          if (variantTitle) params.set('variant', variantTitle);
          if (image) params.set('image', image);

          // 路径增加语言前缀（同域相对路径），并拼接查询字符串
          const baseWithPrefix = this.withLocalePrefix(rawBase);
          const finalUrl = (() => {
            try {
              if (/^https?:\/\//i.test(baseWithPrefix)) {
                const u = new URL(baseWithPrefix);
                // 追加（保留原有参数）
                const merged = new URLSearchParams(u.search || '');
                params.forEach((v, k) => merged.set(k, v));
                u.search = merged.toString();
                return u.toString();
              }
              // 相对路径
              const sep = baseWithPrefix.includes('?') ? '&' : '?';
              return `${baseWithPrefix}${sep}${params.toString()}`;
            } catch (_) {
              const sep = rawBase.includes('?') ? '&' : '?';
              return `${rawBase}${sep}${params.toString()}`;
            }
          })();

          window.location.href = finalUrl;
        } catch (_) {
          // 回退：不带语言前缀也直接跳转到默认地址页
          const fallbackParams = new URLSearchParams({ quantity: '1' });
          window.location.href = `/pages/address?${fallbackParams.toString()}`;
        }
      }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }

    // 读取产品详情页上最终显示的价格文本（促销价优先）
    getDisplayedPriceText() {
      try {
        const saleEl = document.querySelector('.price .price-item--sale.price-item--last');
        const regEl = document.querySelector('.price .price-item.price-item--regular');
        const text = (saleEl || regEl)?.textContent || '';
        return String(text || '').trim();
      } catch (_) {
        return '';
      }
    }

    // 尝试检测当前活动币种（避免依赖第三方插件的专有键）
    detectActiveCurrency(fallback) {
      try {
        const fromShopify = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : '';
        const fromCurrencyJS = (window.Currency && (window.Currency.currentCurrency || (window.Currency.cookie && window.Currency.cookie.read && window.Currency.cookie.read()))) || '';
        const fromLS = (typeof window.localStorage !== 'undefined') ? (
          localStorage.getItem('currency') ||
          localStorage.getItem('activeCurrency') ||
          ''
        ) : '';
        const fromCookieMatch = (document.cookie || '').match(/(?:^|; )(?:currency|activeCurrency)=([^;]+)/);
        const fromCookie = fromCookieMatch ? decodeURIComponent(fromCookieMatch[1]) : '';
        const fromDom = (document.body && document.body.dataset && document.body.dataset.activeCurrency) ? document.body.dataset.activeCurrency : '';
        const cur = (fromShopify || fromCurrencyJS || fromLS || fromCookie || fromDom || fallback || '').toString().trim();
        return cur ? cur.toUpperCase() : (fallback || '').toUpperCase();
      } catch (_) {
        return (fallback || '').toUpperCase();
      }
    }

    // 从价格文本中解析币种代码或符号（如 "€28,70 EUR" -> EUR）
    parseCurrencyFromPriceText(text) {
      try {
        const s = String(text || '').trim();
        if (!s) return '';
        // 直接匹配 3 位字母的币种代码
        const codeMatch = s.match(/\b([A-Z]{3})\b/);
        if (codeMatch && codeMatch[1]) return codeMatch[1].toUpperCase();
        // 符号映射
        const symbolMap = {
          '€': 'EUR',
          '$': 'USD',
          '£': 'GBP',
          'lei': 'RON',
          'RON': 'RON'
        };
        for (const [sym, code] of Object.entries(symbolMap)) {
          if (s.includes(sym)) return code;
        }
        return '';
      } catch (_) {
        return '';
      }
    }
    // 解析价格文本中的数值部分为 Number
    parsePriceNumber(text) {
      try {
        const raw = String(text || '').trim();
        if (!raw) return NaN;
        const cleaned = raw.replace(/[^0-9.,-]/g, '');
        // 同时包含逗号和点：假定点是千分位，逗号是小数
        if (cleaned.includes(',') && cleaned.includes('.')) {
          const normalized = cleaned.replace(/\./g, '').replace(/,/g, '.');
          return parseFloat(normalized);
        }
        // 仅包含逗号：作为小数点
        if (cleaned.includes(',')) {
          const normalized = cleaned.replace(/,/g, '.');
          return parseFloat(normalized);
        }
        // 仅包含点或纯数字
        return parseFloat(cleaned);
      } catch (_) {
        return NaN;
      }
    }
    // 将完整的locale代码映射到URL路径前缀
    mapLocaleToUrlPrefix(localeCode) {
      const mapping = {
        'zh-CN': 'zh',
        'zh-TW': 'zh-tw',
        'pt-BR': 'pt-br',
        'pt-PT': 'pt-pt',
        'en': 'en',
        'ro': 'ro',
        'es': 'es',
        'fr': 'fr',
        'de': 'de',
        'it': 'it',
        'ja': 'ja',
        'ko': 'ko'
      };
      return mapping[localeCode] || localeCode;
    }

    // 检测当前路径中的语言前缀（如 /zh, /en, /pt-BR）
    getLocalePrefix() {
      try {
        const path = window.location && window.location.pathname ? window.location.pathname : '';
        // 兼容无尾斜杠与带尾斜杠两种情况
        const m = path.match(/^\/(?:([a-z]{2}|[a-z]{2}-[A-Za-z]{2}))(?:\/|$)/);
        if (m && m[1]) {
          return `/${m[1]}`;
        }
        return '';
      } catch (_) {
        return '';
      }
    }

    // 将地址页 URL 补上当前语言前缀，并替换错误的现有前缀（同域相对路径为主）
    withLocalePrefix(url) {
      try {
        const raw = String(url || '');
        // 先从当前路径检测语言前缀；如果未检测到则回退到 data-locale
        let prefix = this.getLocalePrefix();
        if (!prefix) {
          const dsLocale = (this.dataset && this.dataset.locale) ? String(this.dataset.locale).trim() : '';
          if (dsLocale) {
            const mappedLocale = this.mapLocaleToUrlPrefix(dsLocale);
            prefix = `/${mappedLocale}`;
          }
        }
        if (!prefix) return raw; // 无前缀则保持原样

        const replaceLeadingLocale = (path) => {
          try {
            const p = String(path || '');
            const m = p.match(/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?)(?=\/|$)/);
            if (m) {
              // 提取现有前缀并在不匹配时替换
              const m2 = p.match(/^\/([a-z]{2}(?:-[A-Za-z]{2})?)/);
              const current = m2 && m2[1] ? `/${m2[1]}` : '';
              if (current && current !== prefix) {
                return p.replace(/^\/([a-z]{2}(?:-[A-Za-z]{2})?)/, prefix);
              }
              return p; // 已匹配目标前缀
            }
            // 无现有前缀则补上
            if (!p.startsWith(`${prefix}/`)) {
              const clean = p.replace(/^\/+/, '');
              return `${prefix}/${clean}`;
            }
            return p;
          } catch (_) {
            return path;
          }
        };

        // 绝对 URL：同域才处理；不同域不改动
        if (/^https?:\/\//i.test(raw)) {
          const u = new URL(raw, window.location.origin);
          if (u.host === window.location.host) {
            u.pathname = replaceLeadingLocale(u.pathname);
            return u.toString();
          }
          return raw;
        }

        // 相对路径：替换或补上前缀
        return replaceLeadingLocale(raw);
      } catch (_) {
        return url;
      }
    }
  }
  );
}
